require('angular');

angular.module('app').controller('subservicesController', SubservicesController);
SubservicesController.$inject = ['$http', '$scope','$rootScope', '$sce', '$window'];

function SubservicesController($http, $scope,$rootScope, $sce, $window) {
    $scope.selectedSubserviceId         = 0;
    $scope.subservices                  = [];
    $rootScope.$on('pricesForSubservicesLoaded', function (evnt, subservices, selectedSubserviceId) {
        $scope.selectedSubserviceId = selectedSubserviceId;
        $scope.subservices          = subservices;
    });

    $scope.selectSubproduct = function(serviceId){
        $scope.selectedSubserviceId = serviceId;
        $rootScope.$broadcast('subproductSelected',serviceId);
    }

    $scope.goToContactUs = function(){
        //location.hash = "#contactus" ;
        jQuery("#contactus").get(0).scrollIntoView();
    }
}